var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content loading"},[_c('img',{attrs:{"src":require("../assets/images/loading.svg")}}),_vm._v(" "+_vm._s(_vm.loadingText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }